// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"6f0249a9","453":"49cbbe4f","796":"e0daaecb"}[chunkId] + ".chunk.js";
};